import { j as s } from "./kezios-design-system.esm172.js";
import d from "react";
import { Flex as x, Stack as o, Text as l } from "@mantine/core";
import a from "./kezios-design-system.esm217.js";
import { Spacing as r } from "./kezios-design-system.esm135.js";
import { RingIcon as g } from "./kezios-design-system.esm124.js";
const R = ({
  title: e,
  description: c,
  image: t,
  icon: n,
  cta: i,
  reverse: m = !1,
  titleComponent: j
}) => /* @__PURE__ */ s.jsxs(
  x,
  {
    className: a.container,
    gap: r.s24,
    px: r.s8,
    align: "center",
    justify: "space-between",
    wrap: m ? "wrap-reverse" : "wrap",
    children: [
      m && /* @__PURE__ */ s.jsx(p, { image: t }),
      /* @__PURE__ */ s.jsx(
        h,
        {
          title: e,
          description: c,
          icon: n,
          cta: i,
          titleComponent: j
        }
      ),
      !m && /* @__PURE__ */ s.jsx(p, { image: t })
    ]
  }
), h = ({
  title: e,
  description: c,
  icon: t,
  cta: n,
  titleComponent: i
}) => /* @__PURE__ */ s.jsxs(o, { className: a.child, gap: r.s6, children: [
  /* @__PURE__ */ s.jsx(g, { icon: t, color: "primary", size: 24 }),
  /* @__PURE__ */ s.jsxs(o, { gap: r.s8, children: [
    /* @__PURE__ */ s.jsxs(o, { gap: r.s4, children: [
      /* @__PURE__ */ s.jsx(
        l,
        {
          variant: "displaySm.semibold",
          c: "gray.9",
          component: i,
          children: e
        }
      ),
      /* @__PURE__ */ s.jsx(l, { variant: "textLg", c: "gray.6", children: c })
    ] }),
    n
  ] })
] }), p = ({ image: e }) => /* @__PURE__ */ s.jsx(x, { className: a.child, h: "100%", align: "center", justify: "center", children: e && d.cloneElement(e, { className: a.image }) });
export {
  p as ImageItem,
  R as Item,
  h as TextItem
};
